import styled from "styled-components";

const PopupWrap = styled.div<{show: boolean; animate: boolean}>`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 100;
	width: 100%;
	height: 100%;
	animation: ${props => (props.animate ? "fade-in 0.25s forwards" : "fade-out 0.25s forwards")};
	overscroll-behavior: contain;

	${props =>
		props.show
			? `
		display: block;
	`
			: `
		display: none;
	`};

	> div {
		animation: ${props => (props.animate ? "toast-up 0.25s forwards" : "toast-down 0.25s forwards")};
	}

	@keyframes fade-in {
		0% {
			background-color: rgba(0, 0, 0, 0);
		}
		100% {
			background-color: rgba(0, 0, 0, 0.6);
		}
	}
	@keyframes fade-out {
		0% {
			background-color: rgba(0, 0, 0, 0.6);
		}
		100% {
			background-color: rgba(0, 0, 0, 0);
		}
	}

	@keyframes toast-up {
		0% {
			transform: translateY(100%);
		}
		100% {
			transform: translateY(0);
		}
	}
	@keyframes toast-down {
		0% {
			transform: translateY(0);
		}
		100% {
			transform: translateY(100%);
		}
	}
`;

const PopupDimm = styled.div`
	position: fixed;
	top: 0;
	right: 0;
	left: 0;
	bottom: 0;
	z-index: 100;
	width: 100%;
	height: 100%;
	background-color: transparent;
	opacity: 0;
`;

const PopupContainer = styled.div`
	position: absolute;
	left: 0;
	bottom: 0;
	z-index: 101;
	width: 100%;
	min-height: 120px;
	/* height: calc(100vh - 120px); */
	box-sizing: border-box;
	background-color: #fff;
	border-radius: 15px 15px 0 0;
`;
const PopupHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 0 0 50px;
	width: 100%;
	height: 50px;
	padding: 0 15px;
	border-bottom: 1px solid var(--line-color);
	box-sizing: border-box;
	> h3 {
		line-height: 1;
		font-size: 17px;
		font-family: "PT-medium";
		color: #111;
	}
`;

const PopupCloseButton = styled.button`
	position: absolute;
	right: 15px;
	width: 18px;
	height: 18px;
	padding: 0;
	background-color: transparent;
	&::before,
	&:after {
		position: absolute;
		top: 50%;
		left: 50%;
		display: block;
		width: 2px;
		height: 24px;
		transform: translate(-50%, -50%) rotate(135deg);
		background-color: #231f20;
		border-radius: 4px;
		content: "";
	}
	&::after {
		width: 24px;
		height: 2px;
	}
`;
const PopupArea = styled.div`
	height: 100%;
	padding: 30px 15px 0;
	box-sizing: border-box;
	overflow-y: hidden;

	> ul {
		display: flex;
		flex-direction: column;
		gap: 20px;
		height: calc(100vh - 300px);
		padding-bottom: 50px;
		box-sizing: border-box;
		overflow-y: auto;
		overflow-x: hidden;
		> li {
			width: 100%;
			height: 20px;
		}
	}
`;

const RadioWrap = styled.div`
	display: flex;
	align-items: center;
	gap: 9px;
	width: 100%;
	input[type="radio"] {
		position: relative;
		flex: 0 0 auto;
		width: 20px;
		height: 20px;
		padding: 0;
		border-radius: 100%;
		background-color: #fff;
		cursor: pointer;
		&:before {
			position: absolute;
			top: 50%;
			left: 50%;
			width: 0;
			height: 0;
			border-radius: 50%;
			transform: translate(-50%, -50%);
			content: "";
			cursor: pointer;
			transition: all 250ms ease;
			box-sizing: border-box;
		}
		&:focus:not(:disabled) {
			border: 1px solid #111;
			outline: none;
		}
		&:active:not(:disabled) {
			border: 1px solid #111;
			&:checked {
				border: 1px solid #111;
				background-color: #111;
				&:before {
					background-color: #111;
				}
			}
		}
		&:checked {
			border: 1px solid #111;
			background-color: #fff;
			&:before {
				width: 10px;
				height: 10px;
				background-color: #111;
			}
			+ label {
				color: #111;
				font-family: "PT-medium";
			}
		}
		&:disabled {
			border-color: var(--line-color);
			background-color: var(--disabled-color);
			cursor: initial;
			&:before {
				background-color: #999;
				cursor: initial;
			}
			+ label {
				color: #999;
				cursor: initial;
			}
		}
	}
	label {
		width: 100%;
		line-height: 1;
		font-size: 14px;
		color: #555;
		cursor: pointer;
	}
`;

export {PopupDimm, PopupArea, PopupCloseButton, PopupContainer, PopupHeader, PopupWrap, RadioWrap};
